import { FC, useEffect, useState } from 'react'
import { cn } from '@bem-react/classname'
import { getDayCourseThunk } from '@/core/services/App/AppSlice'
import { Wallet } from '@/core/services/Wallets/WalletInterface'
import { useAppDispatch, useAppSelector } from '@/core/store/hooks'
import { useHandleServerError } from '@/hooks/useHandleServerError'
import { currencyDaySelector } from '@/core/services/App/AppSelector'

import { Footer } from '@/components/Layout/Footer'
import { Header } from '@/components/Layout/Header'
import { Faq } from './components/Faq'
import { Guide } from './components/Guide'
import { Hero } from './components/Hero'
import { Info } from './components/Info'
import { Partners } from './components/Partners'
import { TrustUs } from './components/TrustUs'
import { Cryptocurrencies } from './components/Cryptocurrencies'

import './Landing.scss'

const cnLanding = cn('Landing')

export const Landing: FC = () => {
  const dispatch = useAppDispatch()
	const { handleServerError } = useHandleServerError()

	const currencies = useAppSelector(currencyDaySelector)

	const [
		currency,
		// setCurrency
	] = useState<'USD' | 'EUR'>('USD')

	const [data, setData] = useState<Wallet[]>([])

	useEffect(() => {
		if (currencies) {
			const active = currencies.find(el => el.code === currency)

			if (active) {
				const arr: Wallet[] = active.items.map(el => {

					const c = el.from.includes('USDT') ? 'USDT' : el.from

					return {
						symbol: c,
						code: c,
						name: el.from,
						course: el.value,
						balance: el.balances + '',
						balance_available: el.balances + '',
						change: el.change,
					}
				})

				setData(arr)
			}
		}
	}, [currencies, currency])

	useEffect(() => {
		getDayCourse()
	}, [])

	const getDayCourse = async () => {
		try {
			await dispatch(getDayCourseThunk()).unwrap()
		} catch (error) {
			handleServerError(error)
		}
	}
  return (
    <div className={cnLanding()}>
      <div className={cnLanding('wrapper')}>
        <Header isHome />
        <Hero data={data} />
        <Cryptocurrencies currency={currency} data={data} />
        <TrustUs />
        <Guide />
        <Partners />
        <Info />
        <Faq />
        <Footer isHome />
      </div>
    </div>
  )
}
